import Grid from "@components/Grid/Grid";
import { useDevice } from "@utilities/react/get-device/get-device";
import ContactDetails, { ContactDetailsProps } from "./C261_ContactDetails";
import LinkedInContactDetails, {
  ContactLinkedInProps,
} from "./C261_LinkedInContactDetails";
import styles from "./C261_Contact.module.scss";

export interface ContactDetailsExtendedProps {
  contactsExtended: {
    contactDetails: ContactDetailsProps;
    contactLinkedInDetails: ContactLinkedInProps;
  }[];
  isExtended?: boolean;
}

const ContactDetailsExtended = ({
  contactsExtended,
  isExtended,
}: ContactDetailsExtendedProps) => {
  const device = useDevice();
  const isMobile = device === "mobile";

  return (
  <ul className={styles["contact-list"]}>
    {contactsExtended &&
      contactsExtended.map((contacts, i) => (
        <li
          key={`${contacts.contactDetails?.title}${i}`}
          className={styles["contact-container"]}
        >
          <Grid row expanded>
            <Grid column sm={12} md={6}>
              {contacts.contactLinkedInDetails && (
                <LinkedInContactDetails {...contacts.contactLinkedInDetails} />
              )}
            </Grid>
            <Grid column sm={12} md={6}>
              <div className={styles["contact-details"]}>
                {contacts.contactDetails && (
                  <ContactDetails
                    isExtended={isExtended}
                    isDark={!isMobile}
                    {...contacts.contactDetails}
                  />
                )}
              </div>
            </Grid>
          </Grid>
        </li>
      ))}
  </ul>
  );
};

export default ContactDetailsExtended;
